import { useMutation } from '@tanstack/react-query'
import type { StoredFile } from '@/features/students/types'
import { http } from './client'
import type { ApiItem } from '@/types/api'

export type FileCategory = 'avatar' | 'logo' | 'document' | 'import'

/** Uploads to S3/MinIO through the API; returns stored-file metadata (id, public URL, …). */
export function useUploadFile() {
  return useMutation({
    mutationFn: async ({ file, category }: { file: File; category: FileCategory }) => {
      const form = new FormData()
      form.append('file', file)
      form.append('category', category)
      const res = await http.post<ApiItem<StoredFile>>('/files', form)
      return res.data.data
    },
  })
}

export async function downloadFile(downloadUrl: string, filename: string): Promise<void> {
  const res = await http.get<Blob>(downloadUrl.replace(/^\/api\/v1/, ''), { responseType: 'blob' })
  const url = URL.createObjectURL(res.data)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
